"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringifyErrorObject = void 0;
var _ansis = _interopRequireDefault(require("ansis"));
var _isObject = require("./isObject");
const NEWLINE_CHAR = '\r\n';
const stringifyErrorObject = (error, leftPad = '') => {
  let result = leftPad;
  if (error.stack) {
    const stackLinesAsArray = error.stack.split('\n').map(line => _ansis.default.dim(`${leftPad}${line}`));
    result += stackLinesAsArray.join(NEWLINE_CHAR);
  } else {
    // When stack is not defined then just simulate atleast its first line from name and message
    result += _ansis.default.bold(`${error.name || 'Error'}: ${error.message}`);
  }
  if ((0, _isObject.isObject)(error.cause)) {
    result += `${NEWLINE_CHAR}${leftPad}Cause:${NEWLINE_CHAR}`;
    result += stringifyErrorObject(error.cause, leftPad);
  }
  return result;
};
exports.stringifyErrorObject = stringifyErrorObject;
